import React from "react";
import { Typography } from "@material-ui/core";

export const ActivePolls = () => {
  return <Typography>There are no active polls.</Typography>;
};
